import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import BtnSubmit from '../Buttons/BtnSubmit';

const StripMessages = (props) => {
    const [isShowStrip, setIsShowStrip] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    
    useEffect(() => {

        if (props.isShowStrip) {
            setIsOpen(false);

            if (props.timeout)
                hideStrip();
        }

    }, [props.isShowStrip]);

 
    const hideStrip = () => {

        setTimeout(function () {
            setIsShowStrip(false);

            if (props.isSlide)
                setIsOpen(true);

            props.onMessage(false);

        }, props.timeout);
    }

    let strip = (

        <div className={props.isShowStrip && !isOpen ? 'strip-inner' : 'strip-inner-down'}>
            <Row>
                {!props.isErrorMsg ?  <Col xs="1" sm="1" md="1"><div className="circle"><Image src={require('./images/mediumSelectedIcon.svg')} /></div></Col> : <Col xs="1" sm="1" md="1"></Col> }
                <Col className="col-msg" xs="11" sm="11" md="11">{props.message}</Col>
            </Row>
        </div>
    );

    return <div className={`strip_messages_container ${props.isErrorMsg ? 'error-msg' : 'success-msg'}`}>{props.isShowStrip || props.isSlide == true ? strip : null}</div>;
};
export default StripMessages;

